import { LeafCard } from "./card.component.js";
customElements.define("leaf-card", LeafCard);
export {
  LeafCard
};
//# sourceMappingURL=card.js.map
